import { createBrowserRouter } from 'react-router-dom';
import { LazyLoader } from 'shared';
import { Layout } from '../layout';
import { PropFrame } from '../pages/props/frame';

export const router = createBrowserRouter([
  {
    element: <Layout />,
    children: [
      { index: true, element: <LazyLoader loader={() => import('../pages/settings/settings')} /> },
      { path: "alerts", element: <LazyLoader loader={() => import('../pages/alerts')} /> },
      { path: "props",
        children: [
          { index: true, element: <LazyLoader loader={() => import('../pages/props/list')} /> },
          { path: ":prop_id",
            element: <PropFrame />,
            children: [
              { path: "settings", element: <LazyLoader loader={() => import('../pages/props/settings')} /> },
              { path: "schedules", children: [
                { index: true, element: <LazyLoader loader={() => import('../pages/schedules')} /> },
                { path: "new", children: [
                  { path: "germ", element: <LazyLoader loader={() => import('../pages/schedules/new/germ')} /> },
                  { path: "fill", element: <LazyLoader loader={() => import('../pages/schedules/new/fill')} /> },
                  { path: "lights", element: <LazyLoader loader={() => import('../pages/schedules/new/lights')} /> },
                  { path: "flood", element: <LazyLoader loader={() => import('../pages/schedules/new/flood')} /> },
                ]},
                { path: "edit/:id", element: <LazyLoader loader={() => import('../pages/schedules/edit')} /> },
              ]},
              { path: "tasks", element: <LazyLoader loader={() => import('../pages/tasks')} /> },
              { path: "control", element: <LazyLoader loader={() => import('../pages/control')} /> },
              { path: "sensors", element: <LazyLoader loader={() => import('../pages/sensors')} /> },
            ],
          },
        ],
      },
      { path: "settings", element: <LazyLoader loader={() => import('../pages/settings/settings')} /> },
    ], 
  },
  { path: "login", element: <LazyLoader loader={() => import('../pages/login/login')} /> },
  { path: "logout", element: <LazyLoader loader={() => import('../pages/logout/logout')} /> },
  { path: "invitation", element: <LazyLoader loader={() => import('../pages/invitation/invitation')} /> },
  { path: "reset", element: <LazyLoader loader={() => import('../pages/reset/reset')} /> },
]);

export const navigate = (path: string) => {
  router.navigate(path);
};

